import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";

interface ReportTasksOptions {
    reportId: number;
}

export class ReportTasksCollection extends CachingCollection<Backbone.Model> {

    public reportId: number;

    constructor(initialModels?: Object[] | any[], options?: ReportTasksOptions) {
        super(initialModels, options);
        this.reportId = options.reportId;
    }

    url = () => {
        return window.location.origin + '/api/v1/reports/tasks/' + this.reportId;
    };

    comparator = (model) => {
        return model.get('id');
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/ReportTasks.ts